import { useState } from 'react';
import { DefaultButton, Stack, TextField } from '@fluentui/react';

const Shortcuts = ({ handleShortcutPrompt }: { handleShortcutPrompt: (text: string) => void }) => {
  const [discipline, setDiscipline] = useState<string>('');
  const [sector, setSector] = useState<string>('');
  const [seniority, setSeniority] = useState<string>('');
  const [freeText, setFreeText] = useState<string>('');

  const generatePrompt = () => {
    let prompt = `Generate interview questions for candidates in ${discipline}`;

    if (sector) {
      prompt += ` in ${sector} sector`;
    }

    if (seniority) {
      prompt += ` at a ${seniority} level`;
    }

    if (freeText) {
      prompt += ` with additional criteria: ${freeText}`;
    }

    handleShortcutPrompt(prompt);
  };

  return (
    <>
      <Stack horizontal wrap tokens={{ childrenGap: 8 }} styles={{ root: { marginTop: '20px' } }}>
        {discipline && (
          <div
            key="discipline"
            style={{
              backgroundColor: '#0F6CBD',
              color: 'white',
              borderRadius: '16px',
              padding: '4px 12px',
              fontSize: '14px',
              fontWeight: 500,
              marginRight: '8px',
            }}
          >
            {discipline}
          </div>
        )}
        {sector && (
          <div
            key="sector"
            style={{
              backgroundColor: '#0F6CBD',
              color: 'white',
              borderRadius: '16px',
              padding: '4px 12px',
              fontSize: '14px',
              fontWeight: 500,
              marginRight: '8px',
            }}
          >
            {sector}
          </div>
        )}
        {seniority && (
          <div
            key="seniority"
            style={{
              backgroundColor: '#0F6CBD',
              color: 'white',
              borderRadius: '16px',
              padding: '4px 12px',
              fontSize: '14px',
              fontWeight: 500,
              marginRight: '8px',
            }}
          >
            {seniority}
          </div>
        )}
      </Stack>
      <h2
        style={{
          fontFamily: '"Segoe UI"',
          fontStyle: 'normal',
          fontWeight: 400,
          fontSize: '16px',
          lineHeight: '150%',
          display: 'flex',
          alignItems: 'flex-end',
          textAlign: 'center',
          letterSpacing: '-0.01em',
          color: '#616161',
        }}
      >
        {!discipline && 'What discipline is the role you are interviewing for?'}
        {discipline && !sector && !seniority && `what sector is it in?`}
        {discipline && sector && !seniority && `what is the seniority level?`}
      </h2>
      <div>
        {!discipline && (
          <>
            <Stack
              horizontal
              tokens={{ childrenGap: 8 }}
              styles={{
                root: {
                  display: 'flex',
                  flexWrap: 'wrap',
                  marginLeft: 'auto',
                  alignItems: 'center',
                  justifyContent: 'center',
                  maxWidth: '56rem',
                },
              }}
            >
              <Stack horizontal tokens={{ childrenGap: 8 }} styles={{ root: { marginBottom: '8px' } }}>
                <DefaultButton key="accounting-finance" onClick={() => setDiscipline('Accounting & Finance')}>
                  Accounting & Finance
                </DefaultButton>
                <DefaultButton key="communication" onClick={() => setDiscipline('Communication')}>
                  Communication
                </DefaultButton>
                <DefaultButton key="education" onClick={() => setDiscipline('Education')}>
                  Education
                </DefaultButton>
              </Stack>
              <Stack horizontal tokens={{ childrenGap: 8 }} styles={{ root: { marginBottom: '8px' } }}>
                <DefaultButton key="human-resources" onClick={() => setDiscipline('Human Resources')}>
                  Human Resources
                </DefaultButton>
                <DefaultButton key="it" onClick={() => setDiscipline('IT')}>
                  IT
                </DefaultButton>
                <DefaultButton key="legal-governance" onClick={() => setDiscipline('Legal & Governance')}>
                  Legal & Governance
                </DefaultButton>
              </Stack>
              <Stack horizontal tokens={{ childrenGap: 8 }} styles={{ root: { marginBottom: '8px' } }}>
                <DefaultButton key="marketing-sales" onClick={() => setDiscipline('Marketing & Sales')}>
                  Marketing & Sales
                </DefaultButton>
                <DefaultButton key="property-construction" onClick={() => setDiscipline('Property & Construction')}>
                  Property & Construction
                </DefaultButton>
                <DefaultButton key="risk-assurance" onClick={() => setDiscipline('Risk & Assurance')}>
                  Risk & Assurance
                </DefaultButton>
              </Stack>
              <Stack horizontal tokens={{ childrenGap: 8 }} styles={{ root: { marginBottom: '8px' } }}>
                <DefaultButton key="technical-engineering" onClick={() => setDiscipline('Technical & Engineering')}>
                  Technical & Engineering
                </DefaultButton>
              </Stack>
            </Stack>
          </>
        )}

        {discipline && !sector && (
          <>
            <Stack
              horizontal
              tokens={{ childrenGap: 8 }}
              styles={{
                root: {
                  display: 'flex',
                  flexWrap: 'wrap',
                  marginLeft: 'auto',
                  alignItems: 'center',
                  justifyContent: 'center',
                },
              }}
            >
              <DefaultButton
                key="back"
                onClick={() => setDiscipline('')}
                styles={{
                  root: {
                    backgroundColor: '#F3F3F3',
                    color: '#616161',
                  },
                }}
              >
                Back
              </DefaultButton>
              <DefaultButton key="private-sector" onClick={() => setSector('Private Sector')}>
                Private Sector
              </DefaultButton>
              <DefaultButton key="public-sector" onClick={() => setSector('Public Sector')}>
                Public Sector
              </DefaultButton>
              <DefaultButton key="education-sector" onClick={() => setSector('Education')}>
                Education
              </DefaultButton>
              <DefaultButton key="nfp" onClick={() => setSector('NFP')}>
                NFP
              </DefaultButton>
            </Stack>
          </>
        )}

        {discipline && sector && !seniority && (
          <>
            <Stack
              horizontal
              tokens={{ childrenGap: 8 }}
              styles={{
                root: {
                  display: 'flex',
                  flexWrap: 'wrap',
                  marginLeft: 'auto',
                  alignItems: 'center',
                  justifyContent: 'center',
                },
              }}
            >
              <DefaultButton
                key="back"
                onClick={() => setSector('')}
                styles={{
                  root: {
                    backgroundColor: '#F3F3F3',
                    color: '#616161',
                  },
                }}
              >
                Back
              </DefaultButton>
              <DefaultButton key="mid" onClick={() => setSeniority('Mid')}>
                MID
              </DefaultButton>
              <DefaultButton key="senior" onClick={() => setSeniority('Senior')}>
                SENIOR
              </DefaultButton>
              <DefaultButton key="executive" onClick={() => setSeniority('Executive')}>
                EXECUTIVE
              </DefaultButton>
              <DefaultButton key="c-level" onClick={() => setSeniority('C-Level')}>
                C-LEVEL
              </DefaultButton>
            </Stack>
          </>
        )}

        {discipline && sector && seniority && (
          <>
            <Stack horizontalAlign="center" tokens={{ childrenGap: 8 }}>
              <TextField
                style={{ width: '30rem' }}
                placeholder="Additional criteria (specific subject matter expertise or other requirements needed)"
                value={freeText}
                onChange={(e, value) => setFreeText(value || '')}
              />

              <Stack horizontal horizontalAlign="center" style={{ paddingTop: '0.5rem' }} tokens={{ childrenGap: 8 }}>
                <DefaultButton
                  key="back"
                  onClick={() => setSeniority('')}
                  styles={{
                    root: {
                      backgroundColor: '#F3F3F3',
                      color: '#616161',
                    },
                  }}
                >
                  Back
                </DefaultButton>
                <DefaultButton
                  text="Generate Interview Questions"
                  onClick={generatePrompt}
                  styles={{
                    root: { backgroundColor: '#0F6CBD', color: 'white' },
                  }}
                />
              </Stack>
            </Stack>
          </>
        )}
      </div>
    </>
  );
};

export default Shortcuts;
